<msc-organize-knowledge-watch-content-list *ngIf="mode === 'list'" (changeMode)="changeMode('add')"></msc-organize-knowledge-watch-content-list>

<msc-organize-knowledge-watch-content-add *ngIf="mode === 'add'" (changeMode)="changeMode('list')"></msc-organize-knowledge-watch-content-add>
